// MathJax渲染指令
const mathjaxDirective = {
  async mounted(el, binding) {
    await renderMathJax(el, binding.value)
  },
  
  async updated(el, binding) {
    const { value, oldValue } = binding
    
    // 如果值发生变化，重新渲染
    if (value !== oldValue) {
      await renderMathJax(el, value)
    }
  }
}

// 渲染MathJax的公共函数
async function renderMathJax(el, value) {
  if (!value) {
    el.innerHTML = '<div class="preview-placeholder">暂无内容</div>'
    return
  }
  
  el.innerHTML = value || el.innerHTML;

  try {
    if (isMathjaxConfig === false) {

      // 等待MathJax加载完成
      const mathJax = await loadMathJax()
    
    }

    const n = () => {
      if (window.MathJax) {
        if (window.MathJax.typesetPromise) {
          // 使用MathJax 3.2.2的typesetPromise方法进行渲染
          window.MathJax.typesetPromise([el]).then(() => {
            console.log("MathJax rendering completed.")
          }).catch(r => {
            console.error("MathJax rendering failed:", r)
          })
        }
        else if (window.MathJax.typeset) {
          // 使用MathJax 3.2.2的typeset方法进行渲染
          window.MathJax.typeset([el])
        }
        else {
          console.error("MathJax rendering failed:", r)
        }
      }
      else {
        setTimeout(n, 100)
      }
    };
    n()

  } catch (error) {
    console.error('MathJax渲染失败:', error)
    // 如果渲染失败，显示原始文本
    el.innerHTML = `<div style="color: #666; padding: 10px;">${value}</div>`
  }
}

// MathJax加载函数
let mathJaxPromise = null

let isMathjaxConfig = false

function loadMathJax() {
  if (mathJaxPromise) {
    isMathjaxConfig = true
    return mathJaxPromise
  }
  
  mathJaxPromise = new Promise((resolve, reject) => {
    // 检查是否已经加载了MathJax
    if (window.MathJax) {
      isMathjaxConfig = true
      resolve(window.MathJax)
      return
    }
    
    // 配置MathJax
    window.MathJax = {
        // 加载器配置 - 必须先配置加载器
      loader: {
        load: ['[tex]/boldsymbol', '[tex]/ams', '[tex]/noerrors', '[tex]/newcommand', '[tex]/mhchem']
      },

      // TeX 输入配置
      tex: {
        // 行内公式定界符
        inlineMath: [['$', '$'], ['\\(', '\\)'], ['\\\\(', '\\\\)']],
        // 显示公式定界符
        displayMath: [['$$', '$$'], ["\\[", "\\]"]],
        // 处理反斜杠转义
        processEscapes: true,
        // 处理环境
        processEnvironments: true,
        // 自动编号
        tags: 'ams',
        // 加载的扩展包 - 使用正确的格式
        packages: { '[+]': ['ams', 'noerrors', 'newcommand', 'mhchem', 'boldsymbol'] },
        // 自定义宏
        macros: {
          RR: '\\mathbb{R}',
          bold: ['{\\bf #1}', 1]
        },

        // 自动加载配置
        autoload: {
          color: [],
          colorv2: ['color']
        },

        // 配置已加载的包
        internalPackages: {
          'ams': true,
          'noerrors': true,
          'newcommand': true,
          'boldsymbol': true,
          'mhchem': true
        }
      },

      // 输出配置
      chtml: {
        scale: 1,                      // 全局缩放
        minScale: 0.5,                 // 最小缩放
        matchFontHeight: false,        // 不匹配字体高度
        mtextInheritFont: false,       // mtext 继承字体
        merrorInheritFont: true,       // merror 继承字体
        mathmlSpacing: false,          // MathML 间距
        skipAttributes: {},            // 跳过的属性
        exFactor: 0.5,                 // ex 因子
        displayAlign: 'center',        // 显示对齐
        displayIndent: '0'             // 显示缩进
      },

      // 文档选项
      options: {
        skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
        includeHtmlTags: { 'mjx': true }, // 仅处理 `<mjx>` 标签
        ignoreHtmlClass: 'tex2jax_ignore',
        processHtmlClass: 'tex2jax_process',
        enableAssistiveMml: false      // 关闭辅助 MML
      },

      // SVG 输出配置（备用）
      svg: {
        fontCache: 'global'
      }
    }
      
    const script = document.createElement('script')
    script.src = '/math/wangEditor/5.2.1/wangEditor.min.js'
    script.async = true

    script.onerror = (error) => {
      reject(new Error('MathJax加载失败: ' + error))
    }
    
    script.onload = () => {
      // 等待MathJax完全初始化
      const checkMathJax = () => {
        if (window.MathJax && window.MathJax.typesetPromise) {
          isMathjaxConfig = true
          resolve(window.MathJax)
        } else {
          setTimeout(checkMathJax, 50)
        }
      }
      checkMathJax()
    }

    // 创建script标签加载MathJax 3.2.2
    const script1 = document.createElement('script')
    script1.src = '/math/mathjax/3.2.2/es5/tex-mml-chtml.js'
    script1.async = true
    script1.onload = () => {
      document.head.appendChild(script)

      // 等待MathJax完全初始化
      //checkMathJax()
    }
    
    script1.onerror = (error) => {
      reject(new Error('MathJax加载失败: ' + error))
    }
    
    document.head.appendChild(script1)
  })
  
  return mathJaxPromise
}

export default mathjaxDirective